<template>
  <div>
    <div class="row q-col-gutter-md q-mb-md">
      <q-checkbox
        v-model="section.config.showLogo"
        class="col-6 col-sm-3"
        label="Show Logo"
      />
      <q-checkbox
        v-model="section.config.showContactInfo"
        class="col-6 col-sm-3"
        label="Show Contact Info"
      />
      <q-checkbox
        v-model="section.config.showMainLinks"
        class="col-6 col-sm-3"
        label="Show Main Links"
      />
      <q-checkbox
        v-model="section.config.showMoreLinks"
        class="col-6 col-sm-3"
        label="Show More Links"
      />
      <q-checkbox
        v-model="section.config.showCircuitNameInFooter"
        class="col-6 col-sm-3"
        label="Show Circuit Name in Footer"
      />
    </div>
    <div class="row q-col-gutter-md q-mb-md">
      <div class="text-bold">
        Styling
      </div>
    </div>
    <div class="row q-col-gutter-md q-mb-md">
      <q-checkbox
        v-model="section.config.footerDarkMode"
        class="col-6 col-sm-3"
        label="Dark Mode"
        :disable="$q.dark.isActive"
      >
        <q-tooltip v-if="$q.dark.isActive">
          Widget Dark Mode is disabled because the site-wide Dark Mode is enabled.
        </q-tooltip>
      </q-checkbox>

      <q-checkbox
        v-if="siteSocials.length"
        v-model="section.config.showSoicalIcons"
        class="col-6 col-sm-3"
        label="Show Social Icons"
      />
      <q-checkbox
        v-model="section.config.verticalAlignTop"
        class="col"
        label="Make Footer Column Vertical Top Align"
      />
    </div>
    <template v-if="siteSocials.length && section.config.showSoicalIcons">
      <div class="row q-col-gutter-md q-mb-md">
        <div class="col-6 col-sm-3 row items-center">
          <q-radio
            v-model="section.config.socialIconsColor"
            val="full"
          />
          <social-icons
            v-if="currentSite.consumerConfig.showSocialIcons"
            class="col-auto q-ml-md row q-gutter-sm"
            social-icons-color="Full Color"
            icon-size="18px"
          />
        </div>
        <div class="col-6 col-sm-3 row items-center">
          <q-radio
            v-model="section.config.socialIconsColor"
            val="black"
          />
          <social-icons
            v-if="currentSite.consumerConfig.showSocialIcons"
            class="col-auto q-ml-md row q-gutter-sm"
            social-icons-color="black"
            icon-size="18px"
          />
        </div>
        <div class="col-6 col-sm-3 row items-center">
          <q-radio
            v-model="section.config.socialIconsColor"
            val="grey"
          />
          <social-icons
            v-if="currentSite.consumerConfig.showSocialIcons"
            class="col-auto q-ml-md row q-gutter-sm"
            social-icons-color="grey"
            icon-size="18px"
          />
        </div>
        <div class="col-6 col-sm-3 row items-center">
          <q-radio
            v-model="section.config.socialIconsColor"
            val="white"
          />
          <social-icons
            v-if="currentSite.consumerConfig.showSocialIcons"
            class="col-auto q-ml-md row q-gutter-sm"
            social-icons-color="white"
            icon-size="18px"
          />
        </div>
      </div>
    </template>
    <preview
      :section="section"
      class="q-mb-xl"
    />
  </div>
</template>

<script>

import Section from 'src/models/page/Section'
import Preview from 'src/modules/consumer/components/Preview'
import SocialIcons from 'src/modules/consumer/components/SocialIcons'
const socials = ['facebook', 'instagram', 'twitter', 'snapchat', 'youtube', 'tiktok']
export default {
  name: 'ConsumerFooterEditor',
  components: {
    Preview,
    SocialIcons
  },
  props: {
    section: {
      type: Section,
      required: true
    }
  },
  computed: {
    siteSocials () {
      return _.filter(socials, social => this.currentSite[social])
    }
  },
  watch: {
    '$q.dark.isActive': {
      handler () {
        if (this.$q.dark.isActive) {
          this.section.config.footerDarkMode = true
        }
      },
      immediate: true
    }
  },
  configuration: ['currentSite'],
  created () {
    _.extend(this, {
      socials
    })
  },
  methods: {
  }
}

</script>

<style lang="scss" scoped>
</style>
